'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactCopyToClipboard = require('react-copy-to-clipboard');

var _reactSocial = require('react-social');

var _ClipboardIcon = require('../ClipboardIcon');

var _ClipboardIcon2 = _interopRequireDefault(_ClipboardIcon);

var _FacebookIcon = require('../FacebookIcon');

var _FacebookIcon2 = _interopRequireDefault(_FacebookIcon);

var _TwitterIcon = require('../TwitterIcon');

var _TwitterIcon2 = _interopRequireDefault(_TwitterIcon);

var _Alert = require('../Alert');

var _Alert2 = _interopRequireDefault(_Alert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShareArticle = function (_Component) {
  (0, _inherits3.default)(ShareArticle, _Component);

  function ShareArticle(props) {
    (0, _classCallCheck3.default)(this, ShareArticle);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ShareArticle.__proto__ || (0, _getPrototypeOf2.default)(ShareArticle)).call(this, props));

    _this.getAlertClassNames = function () {
      return (0, _classnames2.default)({
        'quiver-share-article__alert': true,
        'quiver-share-article__alert--active': _this.state.copied
      });
    };

    _this.clickedShareIcon = function (shareChannel) {
      return _this.props.onClickLink(shareChannel);
    };

    _this.copyUrlToClipboard = function () {
      _this.setState({ copied: true });
      _this.clickedShareIcon('url');
      setTimeout(function () {
        return _this.setState({ copied: false });
      }, 2500);
    };

    _this.state = { copied: false };
    return _this;
  }

  (0, _createClass3.default)(ShareArticle, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          fbAppId = _props.fbAppId,
          url = _props.url;

      return _react2.default.createElement(
        'div',
        { className: 'quiver-share-article' },
        _react2.default.createElement(
          _reactSocial.FacebookButton,
          {
            appId: fbAppId,
            url: url,
            onClick: function onClick() {
              return _this2.clickedShareIcon('facebook');
            },
            className: 'quiver-share-article__facebook'
          },
          _react2.default.createElement(_FacebookIcon2.default, null)
        ),
        _react2.default.createElement(
          _reactSocial.TwitterButton,
          {
            url: url,
            onClick: function onClick() {
              return _this2.clickedShareIcon('twitter');
            },
            className: 'quiver-share-article__twitter'
          },
          _react2.default.createElement(_TwitterIcon2.default, null)
        ),
        _react2.default.createElement(
          _reactCopyToClipboard.CopyToClipboard,
          {
            text: url,
            onCopy: this.copyUrlToClipboard,
            className: 'quiver-share-article__clipboard'
          },
          _react2.default.createElement(
            'button',
            null,
            _react2.default.createElement(_ClipboardIcon2.default, null)
          )
        ),
        _react2.default.createElement(
          'div',
          { className: this.getAlertClassNames() },
          _react2.default.createElement(
            _Alert2.default,
            null,
            _react2.default.createElement(
              'span',
              { className: 'quiver-share-article__alert__message' },
              'Link copied to clipboard'
            )
          )
        )
      );
    }
  }]);
  return ShareArticle;
}(_react.Component);

ShareArticle.propTypes = {
  fbAppId: _propTypes2.default.string.isRequired,
  url: _propTypes2.default.string.isRequired,
  onClickLink: _propTypes2.default.func.isRequired
};

exports.default = ShareArticle;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/ShareArticle/ShareArticle.js
// module id = 278
// module chunks = 11